const unitDefinitions = {
    kg: {
        step: 0.1,
        remainderSymbol: null,
        remainderMultiple: null,
    },
    lb: {
        step: 0.1,
        remainderSymbol: null,
        remainderMultiple: null,
    },
    st: {
        step: 0.1,
        remainderSymbol: "lb",
        remainderMultiple: 14,
    },
};

function getUnit(symbol) {
    return unitDefinitions[symbol] || unitDefinitions.kg;
}

function setDisabled(nodeList, disabled) {
    for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].disabled = disabled;
    }
}

function setSectionsActive(sections, active) {
    for (let i = 0; i < sections.length; i++) {
        sections[i].classList.toggle("is-hidden", !active);
        setDisabled(sections[i].querySelectorAll("input, select, textarea, button"), !active);
    }
}

function syncSelects(selects, value) {
    for (let i = 0; i < selects.length; i++) {
        selects[i].value = value;
    }
}

function updateNumberStep(inputs, step) {
    for (let i = 0; i < inputs.length; i++) {
        inputs[i].step = step;
    }
}

function getCheckedValue(inputs, fallback) {
    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) {
            return inputs[i].value;
        }
    }
    return fallback;
}

export function initPowerliftingCalculator(root) {
    if (!root) {
        return;
    }

    const bodyMassUnitSelect = root.querySelector("[data-powerlifting-bodymass-unit]");
    const liftMassUnitSelects = root.querySelectorAll("[data-powerlifting-liftmass-unit]");
    const bodyMassInputs = root.querySelectorAll("[data-powerlifting-bodymass]");
    const bodyMassMinorControls = root.querySelectorAll("[data-powerlifting-bodymass-minor-control]");
    const bodyMassMinorInput = root.querySelector("[data-powerlifting-bodymass-minor]");
    const liftMassInputs = root.querySelectorAll("[data-powerlifting-liftmass]");
    const methodInputs = root.querySelectorAll("[data-powerlifting-method]");
    const splitSections = root.querySelectorAll("[data-powerlifting-split]");
    const totalSections = root.querySelectorAll("[data-powerlifting-total]");
    const splitHelp = root.querySelector("[data-powerlifting-split-help]");
    const totalHelp = root.querySelector("[data-powerlifting-total-help]");

    function getLiftMassUnitValue() {
        return liftMassUnitSelects[0] ? liftMassUnitSelects[0].value : "kg";
    }

    function updateBodyMassUnit() {
        if (!bodyMassUnitSelect) {
            return;
        }

        const unit = getUnit(bodyMassUnitSelect.value);
        updateNumberStep(bodyMassInputs, unit.step);

        const hasRemainder = !!unit.remainderSymbol;
        for (let i = 0; i < bodyMassMinorControls.length; i++) {
            bodyMassMinorControls[i].classList.toggle("is-hidden", !hasRemainder);
        }
        if (bodyMassMinorInput) {
            bodyMassMinorInput.disabled = !hasRemainder;
            bodyMassMinorInput.step = unit.step;
            if (unit.remainderMultiple !== null) {
                bodyMassMinorInput.max = String(unit.remainderMultiple - unit.step);
            }
        }

        if (bodyMassUnitSelect.value !== "st") {
            syncSelects(liftMassUnitSelects, bodyMassUnitSelect.value);
            updateLiftMassUnit(false);
        }
    }

    function updateLiftMassUnit(syncBodyMassUnit) {
        const value = getLiftMassUnitValue();
        const unit = getUnit(value);
        syncSelects(liftMassUnitSelects, value);
        updateNumberStep(liftMassInputs, unit.step);

        if (syncBodyMassUnit && bodyMassUnitSelect && value !== "st") {
            bodyMassUnitSelect.value = value;
            updateBodyMassUnit();
        }
    }

    function updateMethod() {
        const method = getCheckedValue(methodInputs, "split");
        const isSplit = method === "split";
        setSectionsActive(splitSections, isSplit);
        setSectionsActive(totalSections, !isSplit);
        if (splitHelp) {
            splitHelp.classList.toggle("is-hidden", !isSplit);
        }
        if (totalHelp) {
            totalHelp.classList.toggle("is-hidden", isSplit);
        }
    }

    if (bodyMassUnitSelect) {
        bodyMassUnitSelect.addEventListener("change", updateBodyMassUnit);
    }
    for (let i = 0; i < liftMassUnitSelects.length; i++) {
        liftMassUnitSelects[i].addEventListener("change", function (event) {
            syncSelects(liftMassUnitSelects, event.target.value);
            updateLiftMassUnit(true);
        });
    }
    for (let i = 0; i < methodInputs.length; i++) {
        methodInputs[i].addEventListener("change", updateMethod);
    }

    updateMethod();
    updateLiftMassUnit(false);
    updateBodyMassUnit();
}

function initPowerliftingCalculators() {
    const forms = document.querySelectorAll("[data-powerlifting-calculator]");
    for (let i = 0; i < forms.length; i++) {
        initPowerliftingCalculator(forms[i]);
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPowerliftingCalculators);
} else {
    initPowerliftingCalculators();
}
